export default __webpack_public_path__ + "static/travel-loan-a7be59a2acd3e4aed06ebcef5aa634ad.webp";